import React from "react";

export default function Content() {
  return (
    <>
      <section className="bg-white">
        <div className="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
          <div className="grid grid-cols-2 gap-4 mt-8">
            <img
              className="w-full rounded-lg"
              src="https://media.istockphoto.com/photos/got-to-make-it-a-productive-night-picture-id886465858?k=20&m=886465858&s=612x612&w=0&h=CN-q-5X6ZiuJET2AIUKz71kvboDpGsmgQCUX9QU9lZQ="
              alt="office content 1"
            />
            <img
              className="mt-4 w-full lg:mt-10 rounded-lg"
              src="https://images.unsplash.com/photo-1536148935331-408321065b18?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZ3JhbW1lcnxlbnwwfHwwfHw%3D&w=1000&q=80"
              alt="office content 2"
            />
          </div>
          <div className="font-light text-gray-500 sm:text-lg ">
            <h2 className="mb-4 text-5xl tracking-tight font-semibold text-gray-900 ">
              Find your passion <br />
              and achieve success
            </h2>
            <p className="mb-4 text-black text-xl">
              Find a job that suits your interest and talents. A high salary is
              not the top priority. Most importantly, You can work according to
              your heart's desire and have a work-life balance.
            </p>
            {/* <p>
              We are strategists, designers and developers. Innovators and
              problem solvers. Small enough to be simple and quick.
            </p> */}
          </div>
        </div>
      </section>
    </>
  );
}
